import dictionary from "./localizedStrings.json";

export const buildtranslatetObject = language => {
  let newObject = {};
  const lang = language === "en-US" || language === "en" ? "en" : "de";
  Object.keys(dictionary).forEach(d => {
    newObject = { ...newObject, [d]: dictionary[d][lang] };
  });
  return newObject;
};

export default buildtranslatetObject;
